<template>
  <div id="overlay">
    <div id="pop-up">
      <Spinner
        class="text-center pt-5"
        name="line-scale-pulse-out-rapid"
        color="#5274eb"
      />
      <h6 class="text-center font-weight-bold mt-4">در حال بارگذاری ..</h6>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>
<style>
#overlay {
  height: 100vh !important;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #26252c5d;
  display: block;
  z-index: 999;
}

#pop-up {
  z-index: 999;
  z-index: 1001;
  top: 37vh;
  left: 37vw;
  position: fixed;
  padding: auto;
  margin: auto;
  width: 25vw;
  height: 25vh;
  background:var(--sidebar-action-bg) !important;
  border-radius: 15px;
}
</style>
